import { useState } from 'react';
import { HiBars3BottomRight } from 'react-icons/hi2';
import { IoChevronDownOutline, IoClose } from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router-dom';
import SubLinkDropdown from './SubLinkDropdown';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openSubIndex, setOpenSubIndex] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const navLinks = [
    {
      name: 'HOME',
      id: '/',
    },
    {
      name: 'ABOUT US',
      id: '/about',
      subLinks: [
        { label: 'COMMUNITY IMPACT', path: '/about/community-impact' },
      ],
    },
    {
      name: 'OUR SERVICES',
      id: '/services',
      subLinks: [
        { label: 'PHYSICAL THERAPY', path: '/services/physical-therapy' },
        {
          label: 'Occupational Therapy',
          path: '/services/occupational-therapy',
        },
        { label: 'Speech Therapy', path: '/services/speech-therapy' },
        {
          label: 'Educational Services',
          path: '/services/educational-service',
        },
        { label: 'Telehealth', path: '/services/telehealth' },
        { label: 'Behavioral Health', path: '/services/behavioral-health' },
        { label: 'Dyslexia', path: '/services/dyslexia' },
      ],
    },
    {
      name: 'OUR TEAM',
      id: '/our-team',
    },
    {
      name: 'YOUR APPOINTMENT',
      id: '/appointment',
      key: 'appointment',
    },

    {
      name: 'RESOURCES',
      id: '/resources',
      subLinks: [{ label: 'Forms', path: '/resources/forms' }],
    },

    {
      name: 'PAY',
      id: '/appointment#payment-section',
      scrollTo: 'payment-section',
      key: 'pay',
    },
    {
      name: 'CONTACT US',
      id: '/contact',
    },
  ];

  const isActive = (path) => {
    return (
      location.pathname === path && !location.search.includes('scroll=payment')
    );
  };

  return (
    <div className="flex items-center w-full bg-gradient-to-r from-[#C572A7] to-[#7F76AF] border-b-[1px] border-[#7F76AF]">
      <div className="hidden md:flex justify-end w-full">
        {navLinks.map((item, index) => (
          <SubLinkDropdown
            key={index}
            item={item}
            navigate={navigate}
            location={location}
            isActive={isActive}
          />
        ))}
      </div>

      {/* Mobile Menu Button */}
      <div className="flex md:hidden justify-end w-full mx-4">
        <HiBars3BottomRight
          className="text-4xl text-white cursor-pointer"
          onClick={() => setIsOpen(true)}
        />
      </div>

      {/* Mobile Popup Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-3/4 bg-gradient-to-r from-[#7F76AF] to-[#C572A7] shadow-lg p-6 flex flex-col z-50 transition-transform ease-in-out duration-500 transform ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Close Button */}
        <div className="flex justify-end">
          <IoClose
            className="text-3xl text-white cursor-pointer"
            onClick={() => setIsOpen(false)}
          />
        </div>

        {/* Menu Items */}
        {navLinks.map((item, index) => (
          <div key={index}>
            <div
              onClick={() => {
                if (location.pathname === item.id) {
                  setIsOpen(false);
                  window.history.replaceState(null, '', `#${item.scrollTo}`);
                  const el = document.getElementById(item.scrollTo);
                  if (el) {
                    setTimeout(() => {
                      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 100);
                  }
                } else {
                  navigate(`${item.id}#${item.scrollTo}`);
                  setIsOpen(false);
                }
              }}
              className={`flex justify-between items-center py-4 text-white text-xl font-semibold cursor-pointer
                 ${
                   isActive(item.id) ? 'bg-primary/90' : ''
                 } active:bg-primary transition-all duration-500 rounded-md px-4 relative z-[180]`}
            >
              <p>{item.name}</p>
              {item.subLinks && (
                <IoChevronDownOutline
                  onClick={(e) => {
                    e.stopPropagation();
                    if (item.subLinks) {
                      setOpenSubIndex(openSubIndex === index ? null : index);
                    }
                  }}
                  className={`${
                    openSubIndex === index ? 'rotate-180' : ''
                  } transition-all duration-500 ease-in-out relative z-[200] w-8 h-8 p-1`}
                />
              )}
            </div>

            {/* Sub-links (if any) */}
            {item.subLinks && openSubIndex === index && (
              <div className="ml-6 my-2 space-y-2">
                {item.subLinks.map((sub, subIdx) => (
                  <div
                    key={subIdx}
                    onClick={() => {
                      navigate(sub.path);
                      setIsOpen(false);
                      setOpenSubIndex(null);
                    }}
                    className={`text-white text-sm font-medium py-2 px-3 rounded-md uppercase active:bg-[#6a4794]/70 ${
                      location.pathname === sub.path ? 'bg-primary/90' : ''
                    } transition`}
                  >
                    {sub.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Navbar;
